import { Head, Link, router } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

interface ReportCategory {
  id: number
  name: string
  status: number
  usage_count: number
}

interface Props {
  report_categories: ReportCategory[]
}

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Manage", href: "/admin/report_categories" },
  { title: "Report Categories", href: "/admin/report_categories" },
]

export default function Index({ report_categories }: Props) {
  const handleDelete = (id: number, usageCount: number) => {
    const message =
      usageCount > 0
        ? "This category is in use. It will be deactivated instead of deleted. Continue?"
        : "Are you sure you want to delete this category?"

    if (confirm(message)) {
      router.delete(`/admin/report_categories/${id}`)
    }
  }

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Report Categories" />

      <div className="p-6">
        <div className="mb-4 flex items-center justify-between">
          <h1 className="text-2xl font-semibold">Report Categories</h1>
          <Link
            href="/admin/report_categories/new"
            className="bg-hpi-dark-blue hover:bg-hpi-blue rounded px-4 py-2 text-white"
          >
            Add Category
          </Link>
        </div>

        {report_categories.length > 0 ? (
          <table className="border-hpi-light-gray w-full border-collapse border">
            <thead>
              <tr className="bg-hpi-pale-gray">
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  ID
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Name
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  In Use
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {report_categories.map((rc) => (
                <tr key={rc.id} className="hover:bg-hpi-pale-blue">
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {rc.id}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {rc.name}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {rc.usage_count > 0 ? rc.usage_count : ""}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    <Link
                      href={`/admin/report_categories/${rc.id}/edit`}
                      className="text-hpi-active-blue mr-2 hover:underline"
                    >
                      Edit
                    </Link>
                    <button
                      onClick={() => handleDelete(rc.id, rc.usage_count)}
                      className="text-hpi-red hover:underline"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-hpi-med-gray">No report categories found.</p>
        )}
      </div>
    </AppLayout>
  )
}
